import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-cp8d',
  templateUrl: './cp8d.component.html',
  styleUrls: ['./cp8d.component.css']
})
export class Cp8dComponent implements OnInit {
 
  urlSafe: string = ""; // Initialize to an empty string
  trustedURL!: SafeResourceUrl;
  receivedData: any;
  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute) { }

  ngOnInit() {
    this.receivedData = history.state.data;
    this.urlSafe = 'https://epre2.hasil.gov.my/HITS_8D/CP8D1_ProfilMajikan?TitleScreen=Profil%20Majikan&lang=BM&Peranan=2&noMajikan=91183300&IdNo=930226025683&IdNoTaxAgent=870514105379&NameTaxAgent=ANG%20KAR%20HSENG&NoKelulusan=01/008033/12/2023';
    this.trustedURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlSafe);
  }
}

